import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from 'redux-thunk';
import mainReducer from "./main-reducer";

let rootReducer = combineReducers({
  mainReducer: mainReducer,
});

// Создаем тип из объединенных редьюсеров
let rootReducerType = rootReducer;

// Создаем хранилище, добавляя промежуточное ПО (middleware) redux-thunk
let store = createStore(rootReducer, applyMiddleware(thunk));

// Присваиваем хранилище глобальной переменной window
window.store = store;

export default store;
